import PropTypes from 'prop-types';
import React, {Component} from 'react';

// Components
import Rating from './rating';

export default class StarRating extends Component {
    static propTypes = {
        starCount: PropTypes.number.isRequired,
        starsFilled: PropTypes.number,
        clickScore: PropTypes.func,
        starStyle: PropTypes.object,
        children: PropTypes.element,
        tooltips: PropTypes.object
    };

    static defaultProps = {
        starStyle: {
            color: 'gold'
        },
        tooltips: {}
    };

    render() {
        return (
            <Rating
                iconCount={this.props.starCount}
                fillCount={this.props.starsFilled}
                clickScore={this.props.clickScore}
                iconStyle={this.props.starStyle}
                iconType="star"
                tooltips={this.props.tooltips}
            >
                {this.props.children}
            </Rating>
        );
    }
}



// WEBPACK FOOTER //
// ./components/star_rating.js